import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import ButtonNewTicket from '../../Components/buttons'
import { BUTTON_CONFIGS } from '../../config/serviceDeskConfigs';

function ModalContent({
  projectId = 1,
  title = 'Modal title',
  etiquetas = { btn_create: 'Crear', btn_cancel: 'Cancelar' },
  children,
  onCancel = () => { },
  createTicket,
  infoUser,
  disabledButton = false
}) {

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
    if (infoUser) infoUser();
  };

  const handleCreate = () => {
    createTicket();
    onCancel();
    toggle();
  };

  const handleCancel = () => {
    toggle();
    onCancel();
  };

  return (
    <>
      <Row>
        <Col xs={12} md={6} lg={2} className='ml-auto mb-3'>
          <ButtonNewTicket
            projectId={projectId}
            etiquetas={etiquetas}
            onclick={toggle} />
        </Col>
      </Row>
      <Modal isOpen={isOpen}
        // toggle={toggle}
        scrollable>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          <div className='row'>{children}</div>
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'center' }}>
          <Button
            {...BUTTON_CONFIGS[projectId].modal.btnPrimary}
            disabled={disabledButton}
            onClick={handleCreate}>
            {etiquetas.btn_create}</Button>
          <Button
            {...BUTTON_CONFIGS[projectId].modal.btnSecondary}
            onClick={handleCancel}
          >
            {etiquetas.btn_cancel}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ModalContent.propTypes = {
  projectId: PropTypes.number,
  title: PropTypes.string,
  etiquetas: PropTypes.shape({
    btn_create: PropTypes.string,
    btn_cancel: PropTypes.string
  }),
  children: PropTypes.node,
  onCancel: PropTypes.func,
  createTicket: PropTypes.func.isRequired,
  infoUser: PropTypes.func,
  disabledButton: PropTypes.bool
};

export default ModalContent;